const initMenuToggle = () => {
	const toggle = document.querySelector('[data-toggle="site-menu"]');
	const nav = document.getElementById('primary-nav');
	const backdrop = document.querySelector('[data-menu-backdrop]');
	const closeBtn = nav?.querySelector('.menu-close');
	const header = document.querySelector('.site-header');

	if (!toggle || !nav) {
		return;
	}

	const closeMenu = () => {
		nav.classList.remove('is-open');
		toggle.classList.remove('is-active');
		toggle.setAttribute('aria-expanded', 'false');
		backdrop?.classList.remove('is-open');
		header?.classList.remove('site-header--menu-open');
	};

	toggle.addEventListener('click', (event) => {
		event.stopPropagation();
		const isOpen = nav.classList.toggle('is-open');
		toggle.classList.toggle('is-active', isOpen);
		toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		backdrop?.classList.toggle('is-open', isOpen);
		header?.classList.toggle('site-header--menu-open', isOpen);
	});

	nav.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => {
			if (nav.classList.contains('is-open')) {
				closeMenu();
			}
		});
	});

	closeBtn?.addEventListener('click', () => {
		closeMenu();
	});

	backdrop?.addEventListener('click', () => {
		closeMenu();
	});

	document.addEventListener('click', (event) => {
		if (!nav.classList.contains('is-open')) {
			return;
		}
		const target = event.target;
		if (nav.contains(target) || toggle.contains(target)) {
			return;
		}
		closeMenu();
	});

	window.addEventListener('resize', () => {
		if (window.innerWidth > 1200 && nav.classList.contains('is-open')) {
			closeMenu();
		}
	});
};

document.addEventListener('DOMContentLoaded', initMenuToggle);

// Header hide on scroll down, show on scroll up
const initHeaderScrollToggle = () => {
	const header = document.querySelector('.site-header');
	if (!header) return;

	let lastScroll = window.scrollY;
	const threshold = 8;
	let headerHeight = header.getBoundingClientRect().height || 120;

	const updateHeaderHeight = () => {
		const inner = header.querySelector('.site-header__inner') || header;
		const wasFixed = header.classList.contains('site-header--fixed');
		const wasScrolled = header.classList.contains('site-header--scrolled');
		if (wasFixed) {
			header.classList.remove('site-header--fixed');
		}
		if (wasScrolled) {
			header.classList.remove('site-header--scrolled');
		}
		headerHeight = inner.getBoundingClientRect().height || 120;
		if (wasFixed) {
			header.classList.add('site-header--fixed');
		}
		if (wasScrolled) {
			header.classList.add('site-header--scrolled');
		}
	};

	const onScroll = () => {
		const current = window.scrollY;
		if (header.classList.contains('site-header--menu-open')) {
			header.classList.add('site-header--fixed');
			header.classList.remove('site-header--hidden');
			header.classList.toggle('site-header--scrolled', current > headerHeight);
			lastScroll = current;
			return;
		}

		const passedHeader = current > headerHeight;
		if (!passedHeader) {
			header.classList.remove('site-header--fixed');
			header.classList.remove('site-header--hidden');
			header.classList.remove('site-header--scrolled');
			lastScroll = current;
			return;
		}

		const diff = current - lastScroll;

		if (diff > threshold) {
			header.classList.add('site-header--hidden');
			header.classList.remove('site-header--fixed');
			header.classList.remove('site-header--scrolled');
		} else if (diff < -threshold) {
			if (header.classList.contains('site-header--hidden')) {
				header.classList.remove('site-header--hidden');
			}
			header.classList.add('site-header--fixed');
			header.classList.add('site-header--scrolled');
		}

		lastScroll = current;
	};

	onScroll();
	window.addEventListener('scroll', onScroll, { passive: true });
	window.addEventListener('resize', () => {
		updateHeaderHeight();
		onScroll();
	});
};

document.addEventListener('DOMContentLoaded', initHeaderScrollToggle);

// Hero devices enter animation
const initHeroDevices = () => {
	const hero = document.querySelector('.hero');
	if (!hero) return;

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					hero.classList.add('is-inview');
					observer.disconnect();
				}
			});
		},
		{ threshold: 0.2 }
	);

	observer.observe(hero);
};

document.addEventListener('DOMContentLoaded', initHeroDevices);

// Menu hover animation text stack (header + footer)
const initMenuHoverText = () => {
	const links = document.querySelectorAll('.primary-menu a');
	if (!links.length) return;

	links.forEach((link) => {
		if (link.querySelector('.menu-link__stack')) return;
		const text = link.textContent.trim();
		if (!text) return;

		link.textContent = '';

		const stack = document.createElement('span');
		stack.className = 'menu-link__stack';
		stack.dataset.text = text;

		const main = document.createElement('span');
		main.className = 'menu-link__text';
		main.textContent = text;

		const accent = document.createElement('span');
		accent.className = 'menu-link__text menu-link__text--accent';
		accent.textContent = text;

		stack.append(main, accent);
		link.appendChild(stack);
	});
};

document.addEventListener('DOMContentLoaded', initMenuHoverText);

// Packages tabs
const initPackageTabs = () => {
	const cards = document.querySelectorAll('.package-card');
	if (!cards.length) return;

	const lockCardHeight = (card) => {
		const current = card.offsetHeight;
		const stored = parseFloat(card.dataset.minHeight || '0');
		const next = Math.max(stored, current);
		card.style.minHeight = `${next}px`;
		card.dataset.minHeight = String(next);
	};

	cards.forEach((card) => {
		const tabs = card.querySelectorAll('.package-card__tab-btn');
		const panels = card.querySelectorAll('.package-card__features');
		if (!tabs.length || !panels.length) return;

		// Set initial lock based on default tab content
		lockCardHeight(card);

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				const target = tab.getAttribute('data-tab');
				tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
				panels.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === target));
				// Keep card from shrinking when switching to shorter tabs
				lockCardHeight(card);
			});
		});
	});
};

document.addEventListener('DOMContentLoaded', initPackageTabs);

// Gallery slider
const initGallerySliders = () => {
	const sliders = document.querySelectorAll('.gallery-slider');
	if (!sliders.length) return;

	sliders.forEach((slider) => {
		const slides = Array.from(slider.querySelectorAll('.gallery-slider__slide'));
		const thumbs = Array.from(slider.querySelectorAll('.gallery-slider__thumb'));
		const prev = slider.querySelector('.gallery-slider__nav--prev');
		const next = slider.querySelector('.gallery-slider__nav--next');
		const thumbsWrap = slider.querySelector('.gallery-slider__thumbs');
		const swipeArea = slider.querySelector('.gallery-slider__main');

		if (!slides.length) return;

		const getPerView = () => (window.innerWidth <= 640 ? 3 : 6);

		const updateThumbScrollMode = () => {
			if (!thumbsWrap) return;
			const perView = getPerView();
			if (thumbs.length > perView) {
				thumbsWrap.classList.add('is-scrollable');
			} else {
				thumbsWrap.classList.remove('is-scrollable');
				thumbsWrap.scrollLeft = 0;
			}
		};

		updateThumbScrollMode();

		let active = 0;

		const scrollThumbIntoView = (idx) => {
			if (!thumbsWrap || !thumbs[idx]) return;
			const perView = getPerView();
			// First items in viewport: reset to start
			if (idx < perView) {
				thumbsWrap.scrollLeft = 0;
				return;
			}

			// From the next item onward, keep a sliding window of visible items
			const startIdx = Math.max(0, Math.min(idx - (perView - 1), thumbs.length - perView));
			const anchorThumb = thumbs[startIdx];
			if (!anchorThumb) return;
			const wrapRect = thumbsWrap.getBoundingClientRect();
			const thumbRect = anchorThumb.getBoundingClientRect();
			const nextLeft = thumbsWrap.scrollLeft + (thumbRect.left - wrapRect.left);
			thumbsWrap.scrollTo({ left: nextLeft, behavior: 'smooth' });
		};

		const setActive = (index) => {
			active = (index + slides.length) % slides.length;
			slides.forEach((slide, idx) => slide.classList.toggle('is-active', idx === active));
			thumbs.forEach((thumb, idx) => thumb.classList.toggle('is-active', idx === active));
			scrollThumbIntoView(active);
		};

		thumbs.forEach((thumb, idx) => {
			thumb.addEventListener('click', () => setActive(idx));
		});

		prev?.addEventListener('click', () => setActive(active - 1));
		next?.addEventListener('click', () => setActive(active + 1));

		// Ensure initial state
		setActive(0);
		updateThumbScrollMode();

		if (swipeArea) {
			let startX = 0;
			let startY = 0;
			let isSwiping = false;

			swipeArea.addEventListener('touchstart', (event) => {
				const touch = event.touches[0];
				if (!touch) return;
				startX = touch.clientX;
				startY = touch.clientY;
				isSwiping = true;
			}, { passive: true });

			swipeArea.addEventListener('touchmove', (event) => {
				if (!isSwiping) return;
				const touch = event.touches[0];
				if (!touch) return;
				const dx = touch.clientX - startX;
				const dy = touch.clientY - startY;
				if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 20) {
					event.preventDefault();
				}
			}, { passive: false });

			swipeArea.addEventListener('touchend', (event) => {
				if (!isSwiping) return;
				const touch = event.changedTouches[0];
				if (!touch) return;
				const dx = touch.clientX - startX;
				const dy = touch.clientY - startY;
				isSwiping = false;
				if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) {
					return;
				}
				setActive(dx < 0 ? active + 1 : active - 1);
			});
		}

		window.addEventListener('resize', () => {
			updateThumbScrollMode();
			scrollThumbIntoView(active);
		});
	});
};

document.addEventListener('DOMContentLoaded', initGallerySliders);

// FAQ accordion
const initFaq = () => {
	const items = document.querySelectorAll('.faq__item');
	if (!items.length) return;

	items.forEach((item) => {
		const btn = item.querySelector('.faq__question');
		const answer = item.querySelector('.faq__answer');
		const toggle = item.querySelector('.faq__toggle');
		if (!btn || !answer) return;

		const setState = (open) => {
			item.classList.toggle('is-open', open);
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (open) {
				answer.hidden = false;
				answer.style.maxHeight = `${answer.scrollHeight}px`;
				answer.style.opacity = '1';
			} else {
				answer.style.maxHeight = '0px';
				answer.style.opacity = '0';
			}
			if (toggle) {
				toggle.textContent = open ? '-' : '+';
			}
		};

		setState(false);
		answer.hidden = true;

		btn.addEventListener('click', () => {
			const isOpen = item.classList.contains('is-open');
			setState(!isOpen);
			if (!isOpen) {
				answer.hidden = false;
			} else {
				setTimeout(() => {
					if (!item.classList.contains('is-open')) {
						answer.hidden = true;
					}
				}, 300);
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', initFaq);

// Floating labels for contact form
const initFloatingLabels = () => {
	const labels = document.querySelectorAll('.contact__form label');
	if (!labels.length) return;

	labels.forEach((label) => {
		const field = label.querySelector('input, textarea');
		if (!field) return;

		if (label.dataset.floatingInit === '1') {
			if (typeof label._updateFloating === 'function') {
				label._updateFloating();
			} else {
				const hasValue = field.value && field.value.trim().length > 0;
				label.classList.toggle('has-value', hasValue);
			}
			return;
		}

		const rawText = label.childNodes[0]?.textContent?.trim() || label.textContent.trim();
		if (!rawText) return;

		label.dataset.label = rawText;
		label.classList.add('is-floating');
		label.dataset.floatingInit = '1';

		const updateState = () => {
			const hasValue = field.value && field.value.trim().length > 0;
			label.classList.toggle('has-value', hasValue);
		};

		label._updateFloating = updateState;

		field.addEventListener('focus', () => label.classList.add('is-active'));
		field.addEventListener('blur', () => label.classList.remove('is-active'));
		field.addEventListener('input', updateState);
		field.addEventListener('change', updateState);

		updateState();
	});
};

document.addEventListener('DOMContentLoaded', initFloatingLabels);
window.addEventListener('load', () => {
	setTimeout(initFloatingLabels, 300);
});

['wpcf7submit', 'wpcf7invalid', 'wpcf7mailsent', 'wpcf7mailfailed', 'wpcf7spam', 'wpcf7reset'].forEach((eventName) => {
	document.addEventListener(eventName, () => {
		setTimeout(initFloatingLabels, 50);
	});
});

// Phone mask for contact form
const initPhoneMask = () => {
	const inputs = document.querySelectorAll('.contact__form input[type="tel"]');
	if (!inputs.length) return;

	const formatPhone = (value) => {
		const raw = value.trim();
		let digits = value.replace(/\D/g, '');
		const hasPlus = raw.startsWith('+');
		const hasCountry = digits.startsWith('1');

		if (!digits && hasPlus) {
			return '+1 (';
		}

		if (hasCountry && digits.length === 1) {
			return '+1 (';
		}

		if (hasCountry && digits.length > 1) {
			digits = digits.slice(1);
		}

		digits = digits.slice(0, 10);
		if (!digits) return '';

		if (digits.length <= 3) {
			return `+1 (${digits}`;
		}
		if (digits.length <= 6) {
			return `+1 (${digits.slice(0, 3)})${digits.slice(3)}`;
		}
		return `+1 (${digits.slice(0, 3)})${digits.slice(3, 6)}-${digits.slice(6)}`;
	};

	inputs.forEach((input) => {
		if (input.dataset.phoneMask === '1') {
			input.value = formatPhone(input.value);
			return;
		}

		input.dataset.phoneMask = '1';
		input.setAttribute('inputmode', 'tel');

		const applyMask = () => {
			const next = formatPhone(input.value);
			if (!next && input.value.trim() === '') {
				input.value = '';
				return;
			}
			input.value = next;
		};

		const allowDigitsOnly = (event) => {
			const key = event.key;
			const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
			if (allowedKeys.includes(key)) {
				return;
			}
			if (key === '+') {
				const allowPlus = input.selectionStart === 0 && !input.value.includes('+');
				if (!allowPlus) {
					event.preventDefault();
				}
				return;
			}
			if (!/^[0-9]$/.test(key)) {
				event.preventDefault();
			}
		};

		input.addEventListener('input', applyMask);
		input.addEventListener('change', applyMask);
		input.addEventListener('blur', applyMask);
		input.addEventListener('keydown', allowDigitsOnly);

		if (input.value && input.value.trim().length > 0) {
			applyMask();
		}
	});
};

document.addEventListener('DOMContentLoaded', initPhoneMask);
window.addEventListener('load', () => {
	setTimeout(initPhoneMask, 300);
});

['wpcf7submit', 'wpcf7invalid', 'wpcf7mailsent', 'wpcf7mailfailed', 'wpcf7spam', 'wpcf7reset'].forEach((eventName) => {
	document.addEventListener(eventName, () => {
		setTimeout(initPhoneMask, 50);
	});
});

// Contact submit icon wrapper (CF7 renders input)
const initContactSubmitIcon = () => {
	const submits = document.querySelectorAll('.contact__form .wpcf7-submit');
	if (!submits.length) return;

	submits.forEach((submit) => {
		if (submit.closest('.contact__submit-wrap')) return;
		const wrap = document.createElement('span');
		wrap.className = 'contact__submit-wrap';
		submit.parentNode?.insertBefore(wrap, submit);
		wrap.appendChild(submit);

		const icon = document.createElement('span');
		icon.className = 'contact__submit-icon';
		icon.setAttribute('aria-hidden', 'true');
		wrap.appendChild(icon);
	});
};

document.addEventListener('DOMContentLoaded', initContactSubmitIcon);

// About video modal
const initVideoModals = () => {
	const modals = document.querySelectorAll('[data-video-modal]');
	if (!modals.length) return;

	const isVideoFile = (url) => /\.(mp4|webm|ogg)(\?.*)?$/i.test(url);

	const getEmbedUrl = (url) => {
		const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/i);
		if (youtubeMatch) {
			return `https://www.youtube.com/embed/${youtubeMatch[1]}?autoplay=1&rel=0`;
		}
		const vimeoMatch = url.match(/vimeo\.com\/(\d+)/i);
		if (vimeoMatch) {
			return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1`;
		}
		return url;
	};

	const buildMedia = (url) => {
		if (isVideoFile(url)) {
			const video = document.createElement('video');
			video.src = url;
			video.controls = true;
			video.autoplay = true;
			video.playsInline = true;
			return video;
		}
		const iframe = document.createElement('iframe');
		iframe.src = getEmbedUrl(url);
		iframe.allow = 'autoplay; fullscreen; picture-in-picture';
		iframe.setAttribute('allowfullscreen', 'true');
		return iframe;
	};

	modals.forEach((modal) => {
		const body = modal.querySelector('.video-modal__body');
		const closeEls = modal.querySelectorAll('[data-video-close]');
		const section = modal.closest('.about');
		if (!section || !body) return;

		const triggers = section.querySelectorAll('[data-video-trigger]');
		if (!triggers.length) return;

		const openModal = (url) => {
			if (!url) return;
			body.innerHTML = '';
			body.appendChild(buildMedia(url));
			modal.classList.add('is-open');
			modal.removeAttribute('hidden');
			document.body.classList.add('is-modal-open');
		};

		const closeModal = () => {
			modal.classList.remove('is-open');
			modal.setAttribute('hidden', '');
			body.innerHTML = '';
			document.body.classList.remove('is-modal-open');
		};

		triggers.forEach((trigger) => {
			trigger.addEventListener('click', (event) => {
				event.preventDefault();
				const url = trigger.dataset.videoUrl || trigger.getAttribute('href');
				openModal(url || '');
			});
		});

		closeEls.forEach((el) => el.addEventListener('click', closeModal));

		modal.addEventListener('click', (event) => {
			if (event.target === modal) {
				closeModal();
			}
		});

		document.addEventListener('keydown', (event) => {
			if (event.key === 'Escape' && modal.classList.contains('is-open')) {
				closeModal();
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', initVideoModals);
